import { Component, OnInit } from '@angular/core';
import { AppFilter } from '@app/shared/models';
import { RateLimitService } from '../../services/rate-limit.service';
import { SuiModalService } from '@richardlt/ng2-semantic-ui';
import {
  ViewRateLimitProfileComponent,
  ViewRateLimitProfileModal,
} from '../../modals/viewRateLimitProfile/viewRateLimitProfile.component';

@Component({
  selector: 'app-users-profile-rate-limit',
  templateUrl: './users-with-rate-limit-profile.component.html',
  styleUrls: ['./users-with-rate-limit-profile.component.scss'],
})
export class UsersRateLimitProfileComponent implements OnInit {
  constructor(
    private rateLimitSvc: RateLimitService,
    private modalService: SuiModalService
  ) {}
  filter = new AppFilter();
  totalItems = 0;
  rows = 10;
  maxSize = 10;
  currentPage = 1;
  pending: boolean;
  success;
  error;
  usersWithRateLimitProfile: any[] = [];

  nextPage(pageNumber: number) {
    this.filter.page = pageNumber;
    this.getUsersWithRateLimitProfile();
  }

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: '',
        op: 'cn',
        data: '',
      },
    ],
  };

  headerFilters = [];
  headers = [];

  searchRecords(event) {
    this.searchFilter.rules[0].data = event;
    this.filter._search = true;

    this.filter.filters = JSON.stringify(this.searchFilter);
    this.filter.page = 1;

    this.getUsersWithRateLimitProfile();
  }

  displayRecords(row) {
    this.filter['rows'] = row;
    this.currentPage = 1;

    this.getUsersWithRateLimitProfile();
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.page = 1;

    this.getUsersWithRateLimitProfile();
  }

  advancedSearch(search) {
    if (search) {
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.filter.page = 1;
    this.getUsersWithRateLimitProfile();
  }

  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });

    this.getUsersWithRateLimitProfile();
  }

  getUsersWithRateLimitProfile() {
    this.pending = true;
    this.rateLimitSvc.getUsersWithRateLimitProfile(this.filter).subscribe(
      (res: any) => {
        this.totalItems = +res.records;
        this.currentPage = +res.page;
        this.rows = this.filter.rows;
        this.pending = false;
        this.usersWithRateLimitProfile = res.rows;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.pending = false;
      }
    );
  }

  view(profile: any) {
    this.modalService.open(
      new ViewRateLimitProfileModal('Rate Limit Profile', {
        ...profile,
      })
    );
  }

  ngOnInit(): void {
    this.getUsersWithRateLimitProfile();
  }
}
